module.exports = __webpack_public_path__ + "img/s8-qa2.972ce560.png";